/**
 * Presentations constants, mirrored from `backend/presentations/constants.js`
 * (MYD-493).
 *
 * The server is the authority: it rejects a deck that breaks any of these. The
 * client needs its own copy so the editor can refuse an edit up front (a
 * seventh block, a block in a region its layout lacks) instead of letting the
 * user build something that then fails to save.
 *
 * `constants.test.ts` imports the backend file and fails if the two drift, so a
 * change on either side has to be made on both.
 */

import type { SlideLayout, Transition } from './types/presentation.types'

export const SLIDE_CAP = 100
export const BLOCKS_PER_SLIDE_CAP = 6

/** Undo depth for the deck editor. */
export const UNDO_LIMIT = 50

/**
 * Each layout's named regions. A block sits in a region; several blocks in one
 * region stack in order. `section` has none: its text is the slide's own title.
 */
export const LAYOUT_REGIONS: Readonly<Record<SlideLayout, readonly string[]>> = {
	title: ['background'],
	section: [],
	'title-body': ['main'],
	'two-col': ['left', 'right'],
	'hero-image': ['hero', 'caption'],
	'map-facts': ['map', 'facts'],
	'kpi-row': ['kpi-1', 'kpi-2', 'kpi-3', 'kpi-4', 'body'],
	compare: ['left', 'center', 'right'],
}

export const LAYOUTS = Object.keys(LAYOUT_REGIONS) as SlideLayout[]
export const DEFAULT_LAYOUT: SlideLayout = 'title-body'

export const TRANSITIONS: readonly Transition[] = ['flip', 'slide', 'fade', 'none']
export const DEFAULT_TRANSITION: Transition = 'flip'

export const DEFAULT_THEME = 'default'
